import { render, staticRenderFns } from "./edit-dates-closed-popup.vue?vue&type=template&id=1b2424b2"
import script from "./edit-dates-closed-popup.vue?vue&type=script&lang=js"
export * from "./edit-dates-closed-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports